import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';
import { SidenavService } from 'src/app/core/services/sidenav/sidenav.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
})
/**
 * Navigation bar, always shown below
 */
export class NavigationBarComponent {
  RoutesKeys = RoutesKeys;
  private _home: boolean = false;
  homeLabel = 'home';
  menuItems: SideMenuItems = new SideMenuItems();
  navItems: string[][] = [];

  /**
   * @constructor
   */
  constructor(
    public translationService: TranslationService,
    private sidenavService: SidenavService
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.navItems = this.sidenavService.getMenuItems();
    this.translateItems(this.navItems);
  }

  /**
   * Whether home is active or not
   */
  @Input()
  get home(): boolean {
    return this._home;
  }

  /**
   * Sets this home item as active
   * @param {any} value value might be any type and it is coerced into a boolean
   */
  set home(value: any) {
    this._home = coerceBooleanProperty(value);
  }

  /**
   * Translates string
   * @param {string[]} list
   */
  private translateItems(list: string[][]) {
    for (const item of list) {
      this.translationService.translateString(item[0]).then((translated) => {
        item[2] = translated;
      });
    }
  }
}
